export const STEPS = Object.freeze({
  CHECK_AVAILABILITY: 1,
  AVAILABLE: 2,
  ERROR: 3,
  NOTIFY_AVAILABILITY: 4,
  SUCCESS_NOTIFY_AVAILABILITY: 5,
});

export const defaultValues = {
  plzOrt: '',
  gemeinde: '',
  strasse: '',
  gebadr1: '',
  stiege: '',
  tuerNr: '',
};
